import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const selectPropTypes = {
    autoComplete: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    hint: PropTypes.string,
    inputId: PropTypes.string.isRequired,
    inputRef: PropTypes.func,
    invalid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    validationMessage: PropTypes.string,
    value: PropTypes.string,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=Select.types.js.map